import { Api } from "@/plugins/api"

const catalogue = (code) => {
    return Api.get(`catalogues/${code}`)
}

export default {
    civilites: () => {
        return catalogue(205)
    },
    provinces: () => {
        return catalogue(307)
    },
    pays: () => {
        return catalogue(303)
    },
    professions: () => {
        return catalogue(208)
    },
    categoriesMembre: () => {
        return catalogue(5900)
    },
    donSources: () => {
        return catalogue(3416)
    },
    adhesionSources: () => {
        return catalogue(6521)
    },
    versionsRevue: () => {
        return catalogue(6525)
    }
}
